/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = NotAssociated
 *
 * 1 = EmployeePartners
 *
 * 2 = RetailerPartners
 *
 * 3 = AssociatePartners
 */
export enum AssociationType {
  NotAssociated = 0,
  EmployeePartners = 1,
  RetailerPartners = 2,
  AssociatePartners = 3,
}
